// extracted by mini-css-extract-plugin
export var content = "_mq-1";
export var divider = "_mq-0";